import React, {useState} from "react";
import {ApiUrl} from "../../../auth/authMethods";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import FormHelperText from "@mui/material/FormHelperText";
import PopupAdd from "../../../component/PopupAdd/PopupAdd";
import SendIcon from '@mui/icons-material/Send';
import {Radio, RadioGroup} from "@mui/material";

export default function PopupSendAllBankslips({id}) {

    const [notifyEmail, setNotifyEmail] = useState(true)
    const [notifyWhatsapp, setNotifyWhatsapp] = useState(true)
    const [template, setTemplate] = useState('TODOS_BOLETOS')

    const error = (!notifyEmail && !notifyWhatsapp)

    const url = `${ApiUrl}/boletos/send/all/${id}`

    const icon = <SendIcon fontSize="large" id="icon-svg"/>

    const buttonText = <span>
        <SendIcon fontSize="medium"/> &nbsp;
        Enviar todos os boletos
    </span>

    const returnData = () => {
        setSent(false)
        return {
            notifyEmail,
            notifyWhatsapp,
            template
        }
    }

    const onCloseFunction = () => {
        setSent(false)
        setNotifyEmail(true)
        setNotifyWhatsapp(true)
    }

    const [sent, setSent] = useState(false)

    const inputs = <>
        <Box>
            <FormControl
                required
                error={error}
                component="fieldset"
                sx={{m: 3}}
                variant="standard"
            >
                <FormLabel component="legend">Selecione o(s) método(s) de envio</FormLabel>
                <FormGroup>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={notifyEmail}
                                onChange={() => setNotifyEmail(prevState => !prevState)}
                                name="Enviar email"
                            />
                        }
                        label="Enviar email"
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={notifyWhatsapp}
                                onChange={() => setNotifyWhatsapp(prevState => !prevState)}
                                name="Enviar Whatsapp"
                            />
                        }
                        label="Enviar Whatsapp"
                    />
                </FormGroup>
                {error &&
                    <FormHelperText>Selecione ao menos um método!</FormHelperText>
                }
            </FormControl>
            <br/>
            <FormControl>
                <FormLabel id="demo-radio-buttons-group-label">Selecionar tipo de mensagem</FormLabel>
                <RadioGroup
                    value={template}
                    onChange={(e) => setTemplate(e.target.value)}
                    style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}
                >
                    <FormControlLabel value={'TODOS_BOLETOS'} control={<Radio/>} label="Sem aviso de negativação"/>
                    <FormControlLabel value={'TODOS_BOLETOS_NEGATIVACAO'} control={<Radio/>} label="Com aviso de negativação"/>
                </RadioGroup>
            </FormControl>

            {sent &&
                <p className='text-success'>Mensagem enviada com sucesso!</p>
            }
        </Box>
    </>

    return <PopupAdd
        baseUrl={url} setLoadData={setSent}
        inputs={inputs} title={'Enviar todos os boletos'} icon={icon}
        returnData={returnData}
        buttonClass='dropdown-item'
        button={buttonText} keepOpenAfterSubmit
        onCloseFunction={onCloseFunction}
        disableButton={error}
    />
}